import {aEnsureSellerTradePartnerDocumentsByTradePartnerId} from '../../../../data/seller-trade-partners'

import {AppThunkAction} from '../../../../types/redux'

export const aInitializePage =
  (tradePartnerId: string): AppThunkAction<void> =>
  (dispatch): void => {
    dispatch(aEnsureSellerTradePartnerDocumentsByTradePartnerId(tradePartnerId))
  }
